import "./WhatsappButton.css";

function WhatsappButton() {
  return (
    <a
      href="https://wa.me/971586279149"
      target="_blank"
      rel="noopener noreferrer"
      className="whatsapp-btn"
    >
      <img src="/assets/whatsapp-icon.svg" alt="WhatsApp" />
    </a>
  );
}

export default WhatsappButton;